function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { FilterType } from '@domain-group/fe-allhomes-search-api';
import { AllhomesMobileExpander as Expander, AllhomesMobileDivider as Divider, AllhomesMobileDialogFrame } from '@domain-group/fe-co-allhomes-mobile-dialog';
import AllhomesSearchPriceRange from '@domain-group/fe-co-allhomes-search-price-range';
import AllhomesSearchPropertyType from '@domain-group/fe-co-allhomes-search-property-type';
import AllhomesSearchPropertyFeatures from '@domain-group/fe-co-allhomes-search-property-features';
import MoreOptions from './components/more-options';
import CommonPropTypes, { defaultProps } from './prop-types/common';
import filterStateHandler from './wrappers/filter-state-handler';
import * as styles from './allhomes-search-filter-mobile.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var baseClass = 'allhomes-search-filter-mobile';
class AllhomesSearchFilterMobile extends React.Component {
  constructor(_props) {
    super(_props);
    _defineProperty(this, "onClearAll", () => {
      this.props.onClearAll({
        submit: false
      });
      this.setState({
        resetButtonDisabled: !this.props.hasFilterChanged()
      });
    });
    _defineProperty(this, "onShowResults", () => {
      this.props.onSubmitFilter();
      this.setState({
        resetButtonDisabled: !this.props.hasFilterChanged()
      });
    });
    _defineProperty(this, "getStateFromProps", props => ({
      resetButtonDisabled: !props.hasFilterChanged()
    }));
    _defineProperty(this, "hasAnyFilter", filterTypes => filterTypes.some(filterType => this.props.filters.available().includes(filterType.name)));
    this.state = this.getStateFromProps(_props);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.getStateFromProps(props));
  }
  render() {
    return ___EmotionJSX("div", {
      css: styles.container
    }, ___EmotionJSX("div", {
      css: styles.wrapper
    }, ___EmotionJSX(AllhomesMobileDialogFrame, {
      title: "Filters",
      closeButton: true,
      onClose: this.props.onCancel,
      className: "".concat(baseClass, "__filter-dialogue"),
      rightButton: "Reset all",
      onRightButton: this.onClearAll,
      rightButtonDisabled: this.state.resetButtonDisabled,
      applyButton: "Show results",
      onApplyButton: this.onShowResults
    }, ___EmotionJSX("div", {
      css: styles.priceRange
    }, ___EmotionJSX(AllhomesSearchPriceRange, _extends({}, this.props.priceRangeProps, {
      embedded: true
    }))), this.hasAnyFilter([FilterType.propertyTypes]) && ___EmotionJSX(Divider, null), this.hasAnyFilter([FilterType.propertyTypes]) && ___EmotionJSX(Expander, {
      name: "Property Type",
      summary: this.props.propertyTypeProps.liveTitle
    }, ___EmotionJSX(AllhomesSearchPropertyType, _extends({
      css: styles.priceRange
    }, this.props.propertyTypeProps, {
      embedded: true
    }))), ___EmotionJSX(Divider, null), this.hasAnyFilter([FilterType.beds, FilterType.baths, FilterType.parking]) && ___EmotionJSX(AllhomesSearchPropertyFeatures, _extends({
      css: styles.propertyFeatures
    }, this.props.propertyFeaturesProps, {
      embedded: true
    })), this.hasAnyFilter([FilterType.beds, FilterType.baths, FilterType.parking]) && ___EmotionJSX(Divider, null), ___EmotionJSX("div", {
      css: styles.moreOptions
    }, ___EmotionJSX(Expander, {
      name: "More options",
      openButtonText: "Fewer options",
      expanderStyle: "button"
    }, ___EmotionJSX("div", {
      css: styles.moreOptionsContent
    }, ___EmotionJSX(MoreOptions, _extends({}, this.props.moreOptionsProps, {
      embedded: true
    }))), ___EmotionJSX(Divider, null)), ___EmotionJSX(Divider, null)))));
  }
}
AllhomesSearchFilterMobile.propTypes = _objectSpread({}, CommonPropTypes);
AllhomesSearchFilterMobile.defaultProps = _objectSpread({}, defaultProps);
export default filterStateHandler(AllhomesSearchFilterMobile, {
  isMobile: true
});